<script>
  export let bars = [];

  export let title = '';

  export let desc = '';

  export let barHeight = 300;

  let maxValue = 0;
  let minHeight = 0;

  $: maxValue = bars.reduce((max, cur) => {
    return Math.max(max, cur.value);
  }, 0);

  $: minHeight = barHeight * 0.1;
</script>

<style>
  .bonus-stages {
    position: relative;
    color: #fff;
  }
  .bars {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  .bar {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100px;
    text-align: center;
  }
  .bar .value {
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    width: 50px;
    font-weight: 500;
    background: #37d201;
  }
  .bar .title {
    padding-top: 16px;
  }
  .bar .desc {
    padding-top: 4px;
    font-size: 12px;
    color: var(--T3);
  }
  .bar-title {
    position: absolute;
  }
  .bar-title .text {
    line-height: 64px;
    font-weight: 700;
    font-size: 80px;
    color: #37d201;
  }
  .bar-title .desc {
    padding-top: 24px;
    font-size: 20px;
    color: #999b9f;
  }
  @media screen and (max-width: 640px) {
    .bar-title .text {
      line-height: 32px;
      font-weight: 700;
      font-size: 40px;
    }
    .bar-title .desc {
      padding-top: 8px;
      font-size: 16px;
    }
    .bar .title {
      padding-top: 8px;
      font-size: 14px;
      white-space: normal;
    }
    .bar .desc {
      padding-top: 4px;
      font-size: 12px;
    }
    .bar {
      width: 50px;
    }
    .bar .value {
      border-top-right-radius: 4px;
      border-top-left-radius: 4px;
      width: 25px;
    }
  }
</style>

<div class="bonus-stages">
  <div class="bar-title">
    <span class="text">{title}</span>
    <div class="desc">{desc}</div>
  </div>
  <div class="bars">
    {#each bars as bar}
      <div class="bar">
        <div class="value" style="height: {Math.max(minHeight, ~~((bar.value / maxValue) * barHeight)) + 'px'}" />
        <div class="title wsn f16 fw3">{bar.title}</div>
        <div class="desc">{bar.desc}</div>
      </div>
    {/each}
  </div>
</div>
